<script>
    export default {
        name: "AboutLockbox",
    };
</script>


<template>
    <plain-page class="about-lockbox">
        <h1>
            Why Lockbox
        </h1>

        <p>
            There are plenty decent password managers, so what's the motivation behind Lockbox, and do we
            really need yet another one?
        </p>

        <p>
            The two types of password managers out there are the browser extension ones, and the ones with
            inexplicably bad interfaces. The browser extensions work really hard to put themselves front and center,
            with their auto-logins and form captures and, as much as one might trust them, they require the permission
            to be able to access contents of every page. This is where the security breaks down for us.
            The second group, the one with the bad interfaces, are the brainchilds of security experts with not much
            of an eye for making it usable. Those managers are good, but a pain to use.
        </p>

        <p>
            We wanted to have a standalone, easy to use password manager that would not plug into your browsing habits.
            A simple and secure interface, that doesn't sweat to make every experience seamless, but certainly makes it
            secure.
            You think "I need to log in", you go to Lockbox, fetch the password, and log in. That's it - no song and
            dance. Lockbox locks itself on page close as well as after five minutes of inactivity, so you don't have to
            worry about locking after yourself.
        </p>
        <p>
            In addition, Lockbox also is a place for keeping your private notes. We live in time of public reviews on
            all things. But what if you don't want to hand out that one star to the bad eating experience you had, yet
            also would not want to forget about it so you can avoid it in the future. Or, if you are socially active,
            how does one remember all those people you meet in the meetups. Lockbox has a place for that as well.
        </p>

        <p>
            That's, in short, about it! We hope you'll enjoy using Lockbox. Feel free to reach out if you run into
            any problems, or if you have any ideas for how to improve the experience!
        </p>

        <div class="backlink">
            <a href="/">
                Go to Lockbox
            </a>
        </div>
    </plain-page>
</template>



<style lang="scss">
    .about-lockbox {
        h1 {
            padding-bottom: 1em;
        }

        .backlink {
            text-align: center;
            margin-top: 3em;
        }
    }
</style>
